module.exports = __webpack_public_path__ + "static/media/line-icon.c3c153f1.svg";